(function () {
  'use strict';

  var MASTER_NUMBERS = [11, 22, 33];

  /**
   * Reduce a number to a single digit by summing its digits, or return a Master Number.
   * @param {number} n
   * @returns {number}
   */
  function reduceToLifePath(n) {
    if (MASTER_NUMBERS.indexOf(n) !== -1) return n;
    while (n >= 10) {
      var sum = 0;
      var s = String(n);
      for (var i = 0; i < s.length; i++) {
        sum += parseInt(s[i], 10);
      }
      n = sum;
    }
    return n;
  }

  /**
   * Calculate Life Path Number from month (1-12), day (1-31), year (e.g. 1988).
   * Month: January=1 ... December=12.
   * Sum all digits of month, day, year; reduce to single digit (or 11/22/33).
   */
  function calculateLifePathNumber(month, day, year) {
    var digits = [];
    [month, day, year].forEach(function (val) {
      var str = String(val);
      for (var i = 0; i < str.length; i++) {
        digits.push(parseInt(str[i], 10));
      }
    });
    var sum = digits.reduce(function (a, b) { return a + b; }, 0);
    return reduceToLifePath(sum);
  }

  function findSection() {
    var el = document.querySelector('[data-life-path-calculator]');
    if (!el) return null;
    var sectionId = el.id;
    var configEl = document.getElementById('lpn-config-' + (el.getAttribute('data-section-id') || ''));
    var config = configEl ? JSON.parse(configEl.textContent) : {};
    return {
      root: el,
      sectionId: sectionId,
      config: config
    };
  }

  function getStep(section, name) {
    return section.root.querySelector('[data-lpn-step="' + name + '"]');
  }

  function showStep(section, name) {
    var steps = section.root.querySelectorAll('[data-lpn-step]');
    steps.forEach(function (step) {
      step.setAttribute('hidden', '');
      step.classList.remove('is-active');
    });
    var target = getStep(section, name);
    if (target) {
      target.removeAttribute('hidden');
      target.classList.add('is-active');
    }
    // Scroll to top of page on every step change (mobile-friendly)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function runCalculator(section) {
    var form = section.root.querySelector('[data-lpn-form-dates]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var month = parseInt(form.querySelector('[name="month"]').value, 10);
      var day = parseInt(form.querySelector('[name="day"]').value, 10);
      var year = parseInt(form.querySelector('[name="year"]').value, 10);

      if (!month || !day || !year) return;

      var lifePathNumber = calculateLifePathNumber(month, day, year);
      section._computedLifePath = lifePathNumber;
      section._birthMonth = month;
      section._birthDay = day;
      section._birthYear = year;

      showStep(section, 'loading');

      setTimeout(function () {
        showStep(section, 'email');
        var hiddenInput = section.root.querySelector('[data-lpn-hidden-number]');
        if (hiddenInput) hiddenInput.value = String(lifePathNumber);

        var signupApiUrl = (section.config.signupApiUrl || '').trim();
        var formWrap = section.root.querySelector('[data-lpn-signup-form-wrap]');
        var iframeWrap = section.root.querySelector('[data-lpn-iframe-wrap]');

        if (signupApiUrl && formWrap && iframeWrap) {
          formWrap.removeAttribute('hidden');
          iframeWrap.setAttribute('hidden', '');
        } else {
          if (formWrap) formWrap.setAttribute('hidden', '');
          if (iframeWrap) iframeWrap.removeAttribute('hidden');
          // Legacy: Attentive iframe flow
          var sessionId = makeToken();
          try {
            if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('lpn_session_id', sessionId);
          } catch (e) {}
          var iframe = section.root.querySelector('[data-lpn-iframe]');
          var baseUrl = (section.config.attentiveIframeBaseUrl || '').trim() || 'https://loganhollowell.attn.tv/p/Fbw/landing-page';
          var params = new URLSearchParams();
          params.set('life_path_number', String(lifePathNumber));
          params.set('Life Path Number', String(lifePathNumber));
          params.set('session_id', sessionId);
          var pendingUrl = (section.config.taggingPendingUrl || '').trim();
          if (pendingUrl && typeof fetch !== 'undefined') {
            var token = makeToken();
            params.set('_lpn_token', token);
            fetch(pendingUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ token: token, life_path_number: lifePathNumber }),
              keepalive: true
            }).catch(function () {});
          }
          var iframeSrc = baseUrl + (baseUrl.indexOf('?') !== -1 ? '&' : '?') + params.toString();
          if (iframe) iframe.setAttribute('src', iframeSrc);
          if (section._showContinueButton) {
            if (section._continueFallbackTimer) clearTimeout(section._continueFallbackTimer);
            section._continueFallbackTimer = setTimeout(function () {
              section._continueFallbackTimer = null;
              section._showContinueButton();
            }, 6000);
          }
        }
      }, 1800);
    });
  }

  function makeToken() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }

  function runEmailStep(section) {
    var iframeActions = section.root.querySelector('[data-lpn-iframe-actions]');
    var continueBtn = section.root.querySelector('[data-lpn-iframe-continue]');

    function showContinueAndGoToResults() {
      var lifePathNumber = section._computedLifePath;
      var hiddenInput = section.root.querySelector('[data-lpn-hidden-number]');
      if (hiddenInput) hiddenInput.value = String(lifePathNumber);

      showStep(section, 'results');

      var displayNumber = section.root.querySelector('[data-lpn-display-number]');
      if (displayNumber) displayNumber.textContent = String(lifePathNumber);

      var panels = section.root.querySelectorAll('[data-lpn-result-panel]');
      panels.forEach(function (panel) {
        var num = panel.getAttribute('data-lpn-result-panel');
        if (num === String(lifePathNumber)) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      // Switch the featured-collection-grid to the matching life path collection
      var carousels = section.root.querySelectorAll('.lpn__collection-grid');
      carousels.forEach(function (carousel) {
        var col = carousel.getAttribute('data-collection');
        if (col === String(lifePathNumber)) {
          carousel.classList.add('visible');
        } else {
          carousel.classList.remove('visible');
        }
      });
    }

    function showContinueButton() {
      if (section._continueFallbackTimer) {
        clearTimeout(section._continueFallbackTimer);
        section._continueFallbackTimer = null;
      }
      if (iframeActions) iframeActions.removeAttribute('hidden');

      // POST life_path_number and session_id to webhook so Zapier can correlate with Attentive (if Attentive returns session_id from iframe URL).
      var webhookUrl = (section.config.lifePathWebhookUrl || '').trim();
      if (webhookUrl && typeof fetch !== 'undefined' && section._computedLifePath != null) {
        var sessionId = '';
        try {
          if (typeof sessionStorage !== 'undefined') sessionId = sessionStorage.getItem('lpn_session_id') || '';
        } catch (e) {}
        fetch(webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            life_path_number: section._computedLifePath,
            session_id: sessionId
          }),
          keepalive: true
        }).catch(function () {});
      }
    }
    section._showContinueButton = showContinueButton;

    // Show Continue when Attentive iframe signals success via postMessage, or after a fallback delay.
    // Attentive's landing page may not send postMessage; after 6s we show Continue so the user is never stuck.
    var allowedOrigin = 'https://loganhollowell.attn.tv';
    function onMessage(e) {
      if (e.origin !== allowedOrigin) return;
      var ok = e.data === 'attentive-form-complete' ||
        (e.data && e.data.type === 'attentive-form-complete') ||
        (e.data && e.data.event === 'formSuccess') ||
        (e.data && e.data.success === true);
      if (ok) showContinueButton();
    }
    window.addEventListener('message', onMessage);
    section._messageListener = onMessage;

    if (continueBtn) {
      continueBtn.addEventListener('click', showContinueAndGoToResults);
    }

    // Native form: POST to Signup API (Gadget), then show results
    var signupForm = section.root.querySelector('[data-lpn-signup-form]');
    var signupApiUrl = (section.config.signupApiUrl || '').trim();
    if (signupForm && signupApiUrl && typeof fetch !== 'undefined') {
      signupForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = section.root.querySelector('[data-lpn-signup-email]');
        var phoneEl = section.root.querySelector('[data-lpn-signup-phone]');
        var errorEl = section.root.querySelector('[data-lpn-signup-error]');
        var submitBtn = section.root.querySelector('[data-lpn-signup-submit]');
        var email = emailEl ? (emailEl.value || '').trim() : '';
        if (!email) {
          if (errorEl) {
            errorEl.textContent = 'Please enter your email address.';
            errorEl.removeAttribute('hidden');
          }
          return;
        }
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.setAttribute('hidden', '');
        }
        var phone = phoneEl ? (phoneEl.value || '').trim() : '';
        var lifePathNumber = section._computedLifePath;
        if (lifePathNumber == null) return;
        var body = {
          email: email,
          life_path_number: lifePathNumber
        };
        if (phone) body.phone = phone;
        if (section._birthMonth != null) body.birth_month = section._birthMonth;
        if (section._birthDay != null) body.birth_day = section._birthDay;
        if (section._birthYear != null) body.birth_year = section._birthYear;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }
        fetch(signupApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (res) {
          if (res.ok) {
            showContinueAndGoToResults();
          } else {
            if (errorEl) {
              errorEl.textContent = 'Something went wrong. Please try again.';
              errorEl.removeAttribute('hidden');
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          }
        }).catch(function () {
          if (errorEl) {
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.removeAttribute('hidden');
          }
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
      });
    }
  }

  function init() {
    var section = findSection();
    if (!section) return;
    runCalculator(section);
    runEmailStep(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify section is re-rendered (theme editor)
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
